import axios from "axios";

import { getHeader } from "../headers";

// ===================================================================================
//  GET SECTORS
// ===================================================================================
export const sectorsLoading = () => {
	return {
		type: "SECTORS_ARE_LOADING"
	};
};

export const sectorsError = err => {
	return {
		type: "SECTORS_HAS_ERROR",
		err
	};
};

export const sectorsSuccess = data => {
	return {
		type: "SECTORS_SUCCESS",
		data
	};
};

export function getSectors() {
	return dispatch => {
		dispatch(sectorsLoading());

		return axios
			.get(process.env.REACT_APP_API_URL + "sectors", {
				headers: getHeader()
			})
			.then(response => {
				if (response.data.status && response.data.status !== 200) {
					dispatch(sectorsError(response.data.errors));
				} else {
					dispatch(sectorsSuccess(response.data));
					return Promise.resolve(response);
				}
			})
			.catch(err => {
				dispatch(sectorsError(err.response.data.message));
			});
	};
}



// WEBPACK FOOTER //
// ./src/store/actions/sectors.js